// Feel free to use .env.local file to set API_BASE.
// eslint-disable-next-line no-undef
export const apiBase = process.env.API_BASE || "https://app.twinthread.com/api";

export const resourceBase =
  window.location.hostname.indexOf(".twinthread.com") >= 0 ? "/wwwroot/" : "/";

export const mode = process.env.NODE_ENV;
